// TODO: write code here
// Главный файл 

// Импорт классов и утилит из основного пакета
import { 
    fromEvent,     // превращает события DOM в потоки
    interval,      // создает поток событий каждые N миллисекунд
    merge           // объединяет несколько потоков в один 
} from 'rxjs'; // Это файл внутри node_modules/rxjs/index.js

// Импорт операторов из 'rxjs/operators' (БЕЗ .js!)
import { 
    map,              // преобразование
    startWith,
    switchMap,        // переключение observable
    catchError      // обработка ошибок
} from 'rxjs/operators';

import { fetchUnreadMessages } from './services/messagesApi.js';
import { addNewMessages } from './services/messageStorage.js';
import { MessagesTable } from './components/MessagesTable.js';

const messagesBody = document.getElementById('messagesBody');
const statusSpan = document.getElementById('status');
const refreshBtn = document.getElementById('refreshBtn');

// экземпляр класса для управления таблицей
const messagesTable = new MessagesTable(messagesBody);

/**
 * Обновляет статус в UI 
 * @param {string} status - 'loading', 'success', 'error', 'idle'
 * @param {string} message - Дополнительное сообщение
 */
function updateStatus(status, message = '') {
    // Удаляем все классы статуса
    statusSpan.classList.remove('status-idle', 'status-loading', 'status-success', 'status-error');
    
    switch (status) { // switch — альтернатива множественным if
        case 'loading':
            statusSpan.classList.add('status-loading');
            statusSpan.textContent = message || '⏳ Загрузка...';
            break;
        case 'success':
            statusSpan.classList.add('status-success');
            statusSpan.textContent = message || '✅ Обновлено';
            setTimeout(() => {
                 // выполнится через 2 сек
                if (statusSpan.classList.contains('status-success')) {
                    statusSpan.classList.remove('status-success');
                    statusSpan.classList.add('status-idle');
                    statusSpan.textContent = 'Ожидание обновлений...';
                }
            }, 2000);
            break;
        case 'error':
            statusSpan.classList.add('status-error');
            statusSpan.textContent = message || '❌ Ошибка соединения';
            setTimeout(() => {
                if (statusSpan.classList.contains('status-error')) {
                    statusSpan.classList.remove('status-error');
                    statusSpan.classList.add('status-idle');
                    statusSpan.textContent = 'Ожидание обновлений...';
                }
            }, 3000);
            break;
        default:
            // выполнится, если в switch передан статус, которого нет среди case
            statusSpan.classList.add('status-idle');
            statusSpan.textContent = message || 'Ожидание обновлений...';
    }
}

/**
 * Загружает сообщения с сервера и обновляет UI
 * @returns {Observable} Observable с количеством новых сообщений
 */
function loadMessages() {
    // Меняем статус на "загрузка"
    updateStatus('loading', '⏳ Проверка новых сообщений...');
    
    // Запрашиваем сообщения с сервера
    return fetchUnreadMessages().pipe(
         // возвращает Observable с массивом сообщений
        map(messages => {
            // addNewMessages сохраняет сообщения и возвращает ТОЛЬКО новые
            const newMessages = addNewMessages(messages);
            
            if (newMessages.length > 0) {
                // Добавляем новые сообщения в таблицу
                messagesTable.addMessages(newMessages);
                // Показываем успех с количеством
                updateStatus('success', `📬 Получено ${newMessages.length} новое сообщение`);
            } else {
                // Показываем успех без новых сообщений
                updateStatus('success', '✨ Новых сообщений нет');
            }
            
            return newMessages.length;  // возвращаем количество для статистики
        }), 
        catchError(error => {
            console.error('Ошибка загрузки:', error);
            updateStatus('error', '❌ Не удалось подключиться к серверу');
            return [];
        })
    );
}

// Настройка автоматического обновления
// 1. Периодический опрос каждые 5 секунд (5000 мс)
const polling$ = interval(5000).pipe(  // создает поток, который emits событие каждые 5 секунд
    switchMap(() => loadMessages())   // на каждое событие вызывает loadMessages()
);

// 2. Ручное обновление по кнопке
const manualRefresh$ = fromEvent(refreshBtn, 'click').pipe(  // создает поток кликов по кнопке
    switchMap(() => loadMessages())
);

// 3. Объединяем оба источника (события от таймера и от кнопки) и запускаем
// startWith(null) - делаем первый запрос сразу при загрузке
merge(polling$, manualRefresh$).pipe(
    startWith(null),           // Заставляет сделать первый запрос сразу 
    // при запуске приложения (не ждать 5 секунд)
    switchMap(() => loadMessages())
).subscribe();            //  Запускает весь механизм

// Показываем пустое состояние при старте
messagesTable.showEmptyMessage();

console.log('Приложение запущено, опрос каждые 5 секунд');

// switchMap(() => loadMessages()):
// Если предыдущий запрос еще не завершился, а пришел новый
// (npm run lint -- --fixнапример, быстро кликнули), switchMap отменяет
//  старый запрос и начинает новый.